Vue.asyncComponent('bp-hidden-block-list', {
    props: {
        blocks: {
            type: Array
        }
    },
    methods: {
        showBlock(block) {
            this.$emit('blockPropertyChanged', {blockId: block.id, isHidden: !block.isHidden})
        }
    }
}, 'blueprints/editor/bp-hidden-block-list.html');